import myAxios from "@/plugins/axios";

const ResultService = {

	getResultSubjects(params) {

		let queryParams = Object.keys(params).map(key => key + '=' + params[key]).join('&');

		let resultsUrl = `/result/subject`

		let apiUrl = queryParams ? `${resultsUrl}?${queryParams}` : resultsUrl;

		return myAxios.privateInstance
			.get(apiUrl).then(resp => {
				return resp
			})
			.catch(error => {
				throw new Error(error);
			});
	},

	createSubject(subject) {

		return myAxios.privateInstance
			.post(`/result/subject`, subject).then(resp => {
				return resp
			})
			.catch(error => {
				throw new Error(error);
			});
	},

	updateSubject(subject) {

		return myAxios.privateInstance
			.put(`/result/subject/${subject.id}`, subject).then(resp => {
				return resp
			})
			.catch(error => {
				throw new Error(error);
			});
	},
}

export default ResultService